module.exports = __webpack_public_path__ + "img/pouting-face.b571da56.png";